import React from 'react'

import SvgIcon from 'Pods/Shared/SvgIcon'

function FacebookIcon() {
  return (
    <SvgIcon>
      <i className="custom-font-icon icon-facebook" />
    </SvgIcon>
  )
}

export default FacebookIcon
